import React from 'react'
import { Fade } from 'react-awesome-reveal'

function Hero() {
    const handleSubmit = (e) => {
        e.preventDefault()
    }
    return (
        <section className="section-banner padding-t-100">
            {/* Border Them  */}
            <div className="top_outline_01"></div>
            <div className="top_outline_02"></div>
            <div className="bottom_outline_01"></div>
            <div className="bottom_outline_02"></div>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <Fade triggerOnce duration={2000} direction='up' className="zx-bg-title">
                            <div className="banner w-60">
                                <h1>
                                    Advanced AI software & Web, advanced research for advanced people
                                </h1>
                                <img src="assets/img/effect/theme-1.png" alt="theme" className="theme-1" />
                                <img src="assets/img/effect/theme-2.png" alt="theme" className="theme-2" />
                            </div>
                            <p>
                                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                Dignissimos, necessitatibus.
                            </p>
                            <div className="zx-banner-button d-flex">
                                <div className="mt-20">
                                    <button type="button" className="zx-buttons result-placeholder">Contact Us</button>
                                </div>
                                <div className="zx-coling mt-20">
                                    <i className="fa-solid fa-phone-volume"></i>
                                    <a onClick={handleSubmit} href="/">01(2345)(678)</a>
                                </div>
                            </div>
                        </Fade>
                    </div>
                    <Fade triggerOnce duration={2000} direction='up' className="col-12 padding-t-100">
                        <img src="assets/img/home/banner.png" alt="banner" className="banner-image" />
                    </Fade>
                </div>
            </div>
        </section>
    )
}

export default Hero
